export const setLocalStorageItem = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const getLocalStorageItem = (key) => {
  const value = localStorage.getItem(key);
  return JSON.parse(value);
};

export const formatListItems = (list) => {
  const sortedList = list.sort();
  const formattedList = [];
  sortedList.forEach((item) => {
    formattedList.push({
      id: item,
      name: item.toUpperCase(),
    });
  });

  return formattedList.sort();
};

export const formatSpecialityListItems = (list) => {
  const formattedList = [];
  list.forEach((item) => {
    formattedList.push({
      id: item.toUpperCase(),
      name: item.toUpperCase(),
    });
  });
  return formattedList;
};
